export const swapCaseFirstLetter = (inputString, capitalize = false) => {
  if (inputString.length > 0) {
    if (capitalize) {
      return inputString[0].toUpperCase() + inputString.substring(1)
    }

    return inputString[0].toLowerCase() + inputString.substring(1)
  } else {
    return inputString
  }
}

export const parseStringToObject = (input) => {
  const parseValue = (value) => {
    // If value starts with {, it's a nested object, so parse recursively
    if (value.startsWith('{')) {
      return parseObject(value)
    }

    // If it's a number, parse it as number
    if (!isNaN(value)) {
      // Numeric string preserved as string
      if (Number(value).toString().length !== value.length) {
        return value
      }
      return Number(value)
    }

    // If it's boolean
    if (value === 'true') return true
    if (value === 'false') return false

    // Otherwise, treat it as string
    return value
  }

  const parseObject = (str) => {
    // Remove outer braces
    str = str.trim().slice(1, -1)

    const result = {}
    let key = ''
    let value = ''
    let depth = 0
    let inValue = false
    let buffer = ''

    for (let i = 0; i < str.length; i++) {
      const char = str[i]

      if (char === '=' && depth === 0 && !inValue) {
        key = buffer.trim()
        buffer = ''
        inValue = true
      } else if (char === '{') {
        depth++
        buffer += char
      } else if (char === '}') {
        depth--
        buffer += char
      } else if (char === ',' && depth === 0 && inValue) {
        value = buffer.trim()
        result[key] = parseValue(value)
        buffer = ''
        inValue = false
      } else {
        buffer += char
      }
    }

    // Final key-value pair
    if (inValue) {
      value = buffer.trim()
      result[key] = buffer.length > 0 ? parseValue(value) : ''
    }

    return result
  }

  try {
    return JSON.parse(input)
  } catch (e) {
    return parseObject(input)
  }
}
